import { render, staticRenderFns } from "./EditListProjExh.vue?vue&type=template&id=b50daf6e&scoped=true&"
import script from "./EditListProjExh.vue?vue&type=script&lang=js&"
export * from "./EditListProjExh.vue?vue&type=script&lang=js&"
import style0 from "./EditListProjExh.vue?vue&type=style&index=0&id=b50daf6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50daf6e",
  null
  
)

export default component.exports